module.exports = __webpack_public_path__ + "static/media/call_status_ringing_hover.5f081c46.svg";